"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MirEngFilled = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var MirEngFilled = function MirEngFilled(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 36,
    height: 24,
    viewBox: "0 0 36 24",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 24,
    rx: 3,
    fill: "#ECEFF5"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#MirEngFilled_svg__MirEngFilled_svg__clip0_28028_71961)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.37 11.97h-8.044v4.184h2.55v-2.356h1.077l1.446 2.356h2.898l-1.702-2.553c.819-.293 1.467-.887 1.775-1.63z",
    fill: "#064"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.163 8.183c.011.214.043.422.09.623.011.045.021.09.034.135l.016.054a3.566 3.566 0 003.4 2.492h4.71a2.797 2.797 0 00-.867-2.564 2.795 2.795 0 00-1.895-.74h-5.488z",
    fill: "url(#MirEngFilled_svg__MirEngFilled_svg__paint0_linear_28028_71961)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.733 9.23l-1.056 3.663h-.182L10.44 9.231a1.45 1.45 0 00-1.393-1.048H6.513v7.97H9.05v-4.71h.18l1.45 4.71h1.812l1.45-4.71h.18v4.71h2.537v-7.97h-2.533a1.45 1.45 0 00-1.393 1.048zm5.013 6.924h2.537v-7.97h-2.537v7.97z",
    fill: "#064"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "MirEngFilled_svg__MirEngFilled_svg__paint0_linear_28028_71961",
    x1: 21.163,
    y1: 9.835,
    x2: 29.459,
    y2: 9.835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50A9DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D3E91"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "MirEngFilled_svg__MirEngFilled_svg__clip0_28028_71961"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(4 8)",
    d: "M0 0h28v8.296H0z"
  }))));
};

exports.MirEngFilled = MirEngFilled;
var _default = MirEngFilled;
exports.default = _default;